import React, { useMemo, useState } from "react";
import { DISTRIBUTION_STATUSES } from "./api";
import { formatDate } from "../../lib/format";
import { CustomIcon } from "../shared/CustomIcon";

// Distribution Log — tracks which team member is handling each donated item.
export default function DistributionTab({ distributions, intakes, currentUser, users, onDelete, onNew, onEdit }) {
  const [status, setStatus] = useState("");
  const [assigneeId, setAssigneeId] = useState("");

  const intakeById = useMemo(() => {
    const m = {};
    (intakes || []).forEach(i => { m[i.id] = i; });
    return m;
  }, [intakes]);
  const userById = useMemo(() => {
    const m = {};
    (users || []).forEach(u => { m[u.id] = u; });
    return m;
  }, [users]);

  const filtered = useMemo(() => (
    distributions.filter(d =>
      (!status || d.status === status) &&
      (!assigneeId || d.assignedTeamMemberId === assigneeId)
    )
  ), [distributions, status, assigneeId]);

  const remove = async (d) => {
    if (!window.confirm("Remove this distribution record?")) return;
    await onDelete(d);
  };

  return (
    <div data-testid="distribution-tab">
      <div className="don-toolbar">
        <div className="don-toolbar-filters">
          <select className="don-filter-select" data-testid="dist-filter-status" value={status} onChange={e => setStatus(e.target.value)}>
            <option value="">All statuses</option>
            {DISTRIBUTION_STATUSES.map(s => <option key={s}>{s}</option>)}
          </select>
          <select className="don-filter-select" data-testid="dist-filter-assignee" value={assigneeId} onChange={e => setAssigneeId(e.target.value)}>
            <option value="">All team members</option>
            {(users || []).map(u => <option key={u.id} value={u.id}>{u.name}</option>)}
          </select>
        </div>
        <button className="btn btn-gold" data-testid="dist-new-btn" onClick={onNew}>+ New Distribution</button>
      </div>

      {filtered.length === 0 ? (
        <div className="don-empty">No distribution records match your filters yet.</div>
      ) : (
        <div className="don-list" data-testid="dist-list">
          {filtered.map(d => {
            const it = intakeById[d.intakeId];
            const assignee = userById[d.assignedTeamMemberId];
            const recipientLabel = (d._recipientRedacted || d.recipientPrivate) ? "Anonymous" : (d.recipientName || "Anonymous");
            const statusColor = d.status === "Distributed" ? "rgba(255,255,255,0.55)" : d.status === "In Progress" ? "var(--kc-accent)" : "#60a5fa";
            return (
              <div key={d.id} className="don-row" data-testid={`dist-row-${d.id}`} onClick={() => onEdit(d)}>
                <div className="don-row-icon" style={{ display: "inline-flex", alignItems: "center", justifyContent: "center" }}><CustomIcon name="folder" size={18} /></div>
                <div className="don-row-main">
                  <div className="don-row-title">{it ? it.itemName : "(item removed)"}</div>
                  <div className="don-row-meta">
                    <span>Assigned: {assignee ? assignee.name : "—"}</span>
                    <span>Recipient: {recipientLabel}</span>
                    {d.distributionDate && <span>{formatDate(d.distributionDate)}</span>}
                  </div>
                </div>
                <div className="don-row-chips" onClick={e => e.stopPropagation()}>
                  <span className="don-chip" style={{ color: statusColor, background: `${statusColor}1F` }}>{d.status}</span>
                  <button className="btn btn-sm btn-outline" data-testid={`dist-edit-${d.id}`} onClick={() => onEdit(d)}>Edit</button>
                  <button className="btn btn-sm btn-danger" data-testid={`dist-delete-${d.id}`} onClick={() => remove(d)}>Delete</button>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
